import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../Pages/Public/Login/index";
import ForgotPassword from "../Pages/Public/ForgotPassword";
import ResetPassword from "../Pages/Public/ResetPassword";
import CreateNewPassword from "../Pages/Public/CreateNewPassword";
import PasswordChanged from "../Pages/Public/PasswordChanged";
import VerificationLink from "../Pages/Public/VerificationLink";
import Verify from "../Pages/Public/Verify";

const PublicRoutes = ({ setUserType }) => {
  return (
    <Routes>
      <Route path="/login" element={<Login setUserType={setUserType} />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/verification-link" element={<VerificationLink />} />
      <Route path="/verify/:id" element={<Verify />} />
      <Route path="/reset-password/:id" element={<CreateNewPassword />} />
      <Route path="/passwordchanged" element={<PasswordChanged />} />
      <Route path="*" element={<Navigate to={"/login"} />} />
    </Routes>
  );
};

export default PublicRoutes;
